import { Device } from '../../interfaces/devices';
import { devices } from '../../api/devices';

async function fetchDevices(): Promise<Device[]> {
	try {
		return await devices.getDevices();
	} catch (error) {
		throw error;
	}
}

async function fetchDevicesCategory(category: string): Promise<Device[]> {
	try {
		return await devices.getDevicesCategory(category);
	} catch (error) {
		throw error;
	}
}

async function fetchDevice(deviceId: number): Promise<Device> {
	try {
		return await devices.getDevice(deviceId);
	} catch (error) {
		throw error;
	}
}

export const devicesService = {
	fetchDevices,
	fetchDevicesCategory,
	fetchDevice,
};
